// src/containers/experienceAccordion/ExperienceAccordion.js
import React from "react";
import { Fade } from "react-reveal";
import "./ExperienceAccordion.css";

const ExperienceAccordion = ({ sections, theme }) => {
  if (!sections || sections.length === 0) return null;

  // Only keep sections that actually have experiences
  const visibleSections = sections.filter(
    (sec) => sec && Array.isArray(sec.experiences) && sec.experiences.length > 0
  );

  if (visibleSections.length === 0) return null;

  return (
    <div className="experience-accordion">
      {visibleSections.map((section, idx) => (
        <div
          className="experience-section"
          key={section.title || idx}
        >
          <Fade bottom duration={1500} distance="20px">
            {/* Section title: Work / Internships / etc */}
            <h2
              className="experience-section-title"
              style={{ color: theme.text }}
            >
              {section.title}
            </h2>

            <div className="experience-cards">
              {section.experiences.map((exp, i) => (
                <div
                  key={exp.title + i}
                  className="experience-card"
                  style={{
                    borderColor: exp.color || theme.imageHighlight,
                  }}
                >
                  {exp.logo_path && (
                    <img
                      src={require(`../../assets/images/${exp.logo_path}`)}
                      alt={exp.company}
                      className="experience-card-logo"
                    />
                  )}

                  <div className="experience-card-body">
                    <h3
                      className="experience-card-title"
                      style={{ color: theme.text }}
                    >
                      {exp.title}
                    </h3>

                    <h4
                      className="experience-card-company"
                      style={{ color: theme.secondaryText }}
                    >
                      {exp.company}
                    </h4>

                    <p
                      className="experience-card-meta"
                      style={{ color: theme.secondaryText }}
                    >
                      {exp.duration}
                      {exp.location ? ` · ${exp.location}` : ""}
                    </p>

                    <p
                      className="experience-card-description"
                      style={{ color: theme.secondaryText }}
                    >
                      {exp.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Fade>
        </div>
      ))}
    </div>
  );
};

export default ExperienceAccordion;
